import type { ReportSummary } from '../types';
export function groupReportsByDay(items: ReportSummary[]): Array<{ day: string; items: ReportSummary[] }> {
  const groups = new Map<string, ReportSummary[]>();
  for (const item of items) {
    const timestamp = new Date(item.createdAt);
    const day = Number.isFinite(timestamp.getTime()) ? timestamp.toISOString().slice(0, 10) : 'Date unavailable';
    groups.set(day, [...(groups.get(day) || []), item]);
  }
  return [...groups.entries()].map(([day, reports]) => ({ day, items: reports }));
}
